<script>

	import { onMount, onDestroy } from 'svelte';
	import { fly } from "svelte/transition";

	import Nav from './Interactions/Nav.svelte';
	import Chat from './Interactions/Chat.svelte';
	import QA from './Interactions/QA.svelte';
	import Polls from './Interactions/Polls.svelte';

	import { event, syncClient, attendee, session } from '../../lib/stores.js';
	import { autoblur } from '../../lib/autoblur.js';

	let mounted = false;

	let tab = $session.jumpToTab ? $session.jumpToTab : getTabFromInteractions();

	let tracker;

	let spots = {};
	let qaPending = {};

	let mod = ($attendee.type == 'login');

	onMount(() => {
		mounted = true;
	});

	function getTabFromInteractions() {
		let t;
		for (const i of $session.app.interactions) {
			if (i == 'chat') continue;
			t = i;
			break;
		}
		if (!t) {
			t = $session.app.interactions[0];
		}
		return t;
	}

	function setSpot(source) {
		if (tab != source) {
			spots[source] = true;
		}
	}

	function clearSpot() {
		spots[tab] = false;
	}

	async function openTracker() {

		if (tracker) tracker.close();

		spots = {};
		qaPending = {};

		// console.log("opening session channel (tracker)", $session.syncChannel);

		try {
			tracker = await $syncClient.list($session.syncChannel);
		} catch (e) {
			console.log("Sync error", e, $session.syncChannel);
		}
		
		if (tracker) {

			tracker.on('itemAdded', function(i) {
				// console.log('itemAdded', i.item.data);
				if (i.item.data.type == 'qa') {
					if (i.item.data.approved || mod) {
						setSpot(i.item.data.type);
					} else if (i.item.data.sender != $attendee.ref) {
						qaPending[i.item.index] = true;
					}
				} else if (i.item.data.type) {
					setSpot(i.item.data.type);
				}
			});

			tracker.on('itemUpdated', function(i) {
				if (i.item.data.type == 'qa') {
					if (i.item.data.approved && qaPending[i.item.index]) {
						setSpot(i.item.data.type);
						qaPending[i.item.index] = false;
					}
				}
			});
			
		}

	}

	onDestroy(() => {
		if (tracker) tracker.close();
	});

	$: if ($session) {
		openTracker();
	}

	$: if (tab) {
		clearSpot();
	}

</script>

<style>
	.interactions {
		flex: 1 0 auto;
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}
	.interactions > div {
		position: relative;
		flex: 1 0 auto;
	}
</style>

{#if mounted}
	<div class="interactions" in:fly={{ duration: 300, y: 20 }}>
		<Nav bind:tab {spots}/>
		<div>
			{#if $session.syncChannel}
				{#if tab == 'chat'}
					<Chat />
				{:else if tab == 'qa'}
					<QA />
				{:else if tab == 'polling'}
					<Polls />
				{/if}
			{/if}
		</div>
	</div>
{/if}
